import axios from 'axios'

class UserDocService {
  constructor(apiUrl) {
    this.apiUrl = apiUrl
  }

  /**
  * @author Alan Aguilar
  * @description Get if the user has a sign Pfx created previously
  * @date 02-09-2020
  * @param {Number} signStatusId
  * @param {String} token
  * @returns {Object}
  * @memberof 
  */
  async getUserDocPfx(docTypeId, token) {
    let response = await axios.get(`${this.apiUrl}/user-doc-pfx?docTypeId=${docTypeId}`, {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    })
    return response.data
  }


  /**
* @author Adrian Montemayor
* @description Verify the nip
* @date 13/09/2023
* @param {String} nip
* @param {String} token
* @returns {Object}
* @memberof 
*/
  async verifyNip(nip, token) {
    let response = await axios.post(`${this.apiUrl}/verify-nip`, { nip }, {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    })
    return response.data.data
  }

  async getUserDocProfile(file, token) {
    let response = await axios.put(`${this.apiUrl}/user-doc-profile`, file,
      {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      })
    return response.data
  }

  /**
   *
   *
   * @memberof UserDocService
   */
  async getUserDocs(token) {
    return axios.get(`${this.apiUrl}/user-documents`, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    }).then(data => data.data)
      .catch(error => {
        console.log(error)
        return {
          data: null,
          message: "Ocurrió un error al traer los documentos"
        }
      })
  }

}


export { UserDocService as default }
